/* ------------------------------------------------------------------------------
@name: DataTable
--------------------------------------------------------------------------------- */

const DataTable = (() => {
  // handleRunDataTableDefault
  const handleRunDataTableDefault = (
    dataSetting,
    columnSetting,
    columnVisbleSetting
  ) => {
    // --- datatable setting
    const tableSetting = {
      responsive: true,
      processing: true,
      serverSide: true,
      responsive: true,
      autoWidth: false,
      stateSave: true,
      // dom: "Bfrtip",
      // buttons: ["copy", "excel", "pdf"],
      ajax: {
        url: dataSetting.url,
        type: dataSetting.method,
        data: dataSetting ? dataSetting.data : "",
      },
      columnDefs: columnSetting,
    };

    let table = $("." + dataSetting.selector).DataTable(tableSetting);

    // --- setting datatable button
    // table
    // 	.buttons()
    // 	.container()
    // 	.appendTo("#datatable-buttons_wrapper .col-md-6:eq(0)");

    // --- setting visibility column
    if (columnVisbleSetting !== undefined) {
      table
        .columns(columnVisbleSetting.target)
        .visible(columnVisbleSetting.visble);
    }
  };

  // pagination lebih sedikit di mobile
  // if (window.innerWidth <= 768) {
  //   $.fn.DataTable.ext.pager.numbers_length = 3;
  // } else {
  //   $.fn.DataTable.ext.pager.numbers_length = 5;
  // }

  // handleRunDataTableCustom
  const handleRunDataTableCustom = (
    dataSetting,
    filterSetting,
    columnSetting,
    sortSetting = 0,
    columnVisbleSetting = 0
  ) => {
    const tableSetting = {
      bLengthChange: false,
      processing: true,
      serverSide: true,
      responsive: true,
      autoWidth: false,
      stateSave: true,
      info: false,

      ajax: {
        url: dataSetting.url,
        type: dataSetting.method,
        data: dataSetting ? dataSetting.data : "",
      },

      columnDefs: columnSetting,

      language: {
        processing: '<div class="loader"></div>',
        paginate: {
          first: "<<",
          previous: "<",
          next: ">",
          last: ">>",
        },
      },

      // ✅ FIX PAGINATION DI SINI
      drawCallback: function () {
        const api = this.api();
        const pageInfo = api.page.info();
        const $wrapper = $(api.table().container());

        if (pageInfo.pages <= 1) {
          $wrapper.find(".dataTables_paginate").hide();
        } else {
          $wrapper.find(".dataTables_paginate").show();
        }
      },
    };

    let table = $("." + dataSetting.selector).DataTable(tableSetting);

    // --- filter setting
    $.each(filterSetting, (i, v) => {
      if (v.event === "change") {
        $("#" + v.id).on(v.event, () => {
          table.draw();
        });
      } else {
        $("#" + v.id).on(v.event, (e) => {
          let value = $(e.currentTarget).val();
          table.search(value).draw();
        });
      }
    });

    // --- sort setting
    if (sortSetting !== 0) {
      $("#" + sortSetting.id).on(sortSetting.event, (e) => {
        let value = $(e.currentTarget).val();
        table.page.len(value).draw();
      });
    }

    // --- setting visibility column
    if (columnVisbleSetting !== 0) {
      table
        .columns(columnVisbleSetting.target)
        .visible(columnVisbleSetting.visble);
    }

    return table;
  };

  return {
    default: handleRunDataTableDefault,
    custom: handleRunDataTableCustom,
  };
})();

export default DataTable;
